import fetch from './fetch'

const client = fetch()

export interface DashboardResp {
  id: number
  clientId: number
  userId: number
  refId: number
  title: string
  description: string
  tags: string[]
  viewData: Record<string, unknown>
  visibility: string
  createdAt: string
  createdBy: number
  updatedAt: string
  updatedBy: number
}

export interface CreateDashboardReq {
  clientId: number
  refId: number
  title: string
  description?: string
  tags?: string[]
  viewData: Record<string, unknown>
  visibility: string
}

const paths = {
  dashboards: '/dashboards'
}

export const getDashboards = async (clientId: number, refId?: number): Promise<DashboardResp[]> => {
  const searchParams = new URLSearchParams({ client_id: clientId.toString() })
  if (refId != null) {
    searchParams.set('ref_id', String(refId))
  }

  return await client.get<DashboardResp[]>({
    path: `${paths.dashboards}?${searchParams.toString()}`
  })
}

export const getDashboard = async (dashboardId: number, clientId: number): Promise<DashboardResp> => {
  return await client.get<DashboardResp>({ path: `${paths.dashboards}/${dashboardId}?client_id=${clientId}` })
}

export const deleteDashboard = async (dashboardId: number, clientId: number): Promise<DashboardResp> => {
  return await client.del<DashboardResp>({ path: `${paths.dashboards}/${dashboardId}?client_id=${clientId}` })
}

export const createDashboard = async (dashboard: CreateDashboardReq): Promise<DashboardResp> => {
  return await client.post<DashboardResp>({ path: paths.dashboards, data: dashboard })
}

export const updateDashboard = async (
  dashboard: Partial<CreateDashboardReq>,
  clientId: number,
  dashboardId: number
): Promise<DashboardResp> => {
  return await client.patch<DashboardResp>({
    path: `${paths.dashboards}/${dashboardId}?client_id=${clientId}`,
    data: {
      ...dashboard,
      clientId
    }
  })
}
